<template>
    <div class="main-category-lists">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div v-for="category in categories" :key="category._id" class="swiper-slide">
                    <router-link tag="a" class="main-category" :to="`/shop/categories/${category._id}`">
                        <span class="main-category__thumb">
                            <span class="main-category__thumbnail">
                                <span class="main-category__thumbnail-image" :style="{ backgroundImage: `url('${category.icon}')`}"></span>
                            </span>
                            <span class="main-category__thumb-image"></span>
                        </span>
                        <span class="main-category__title">{{ category.name }}</span>
                    </router-link>
                </div>
                <!-- <div class="swiper-slide">
                    <a class="main-category" href="#">
                        <span class="main-category__thumb">
                            <span class="main-category__thumbnail">
                                <span class="main-category__thumbnail-image" style="background-image:url('/images/main/main-pick3.png')"></span>
                            </span>
                            <span class="main-category__thumb-image"></span>
                        </span>
                        <span class="main-category__title">욕실</span>
                    </a>
                </div>
                <div class="swiper-slide">
                    <a class="main-category" href="#">
                        <span class="main-category__thumb">
                            <span class="main-category__thumbnail">
                                <span class="main-category__thumbnail-image" style="background-image:url('/images/main/main-pick4.png')"></span>
                            </span>
                            <span class="main-category__thumb-image"></span>
                        </span>
                        <span class="main-category__title">주방</span>
                    </a>
                </div>
                <div class="swiper-slide">
                    <a class="main-category" href="#">
                        <span class="main-category__thumb">
                            <span class="main-category__thumbnail">
                                <span class="main-category__thumbnail-image" style="background-image:url('/images/main/main-pick5.png')"></span>
                            </span>
                            <span class="main-category__thumb-image"></span>
                        </span>
                        <span class="main-category__title">도배</span>
                    </a>
                </div>
                <div class="swiper-slide">
                    <a class="main-category" href="#">
                        <span class="main-category__thumb">
                            <span class="main-category__thumbnail">
                                <span class="main-category__thumbnail-image" style="background-image:url('/images/main/main-pick6.png')"></span>
                            </span>
                            <span class="main-category__thumb-image"></span>
                        </span>
                        <span class="main-category__title">조명</span>
                    </a>
                </div>
                <div class="swiper-slide">
                    <a class="main-category" href="#">
                        <span class="main-category__thumb">
                            <span class="main-category__thumbnail">
                                <span class="main-category__thumbnail-image" style="background-image:url('/images/main/main-pick7.png')"></span>
                            </span>
                            <span class="main-category__thumb-image"></span>
                        </span>
                        <span class="main-category__title">도어</span>
                    </a>
                </div>
                <div class="swiper-slide">
                    <a class="main-category" href="#">
                        <span class="main-category__thumb">
                            <span class="main-category__thumbnail">
                                <span class="main-category__thumbnail-image" style="background-image:url('/images/main/main-pick8.png')"></span>
                            </span>
                            <span class="main-category__thumb-image"></span>
                        </span>
                        <span class="main-category__title">필름</span>
                    </a>
                </div>
                <div class="swiper-slide">
                    <a class="main-category" href="#">
                        <span class="main-category__thumb">
                            <span class="main-category__thumbnail">
                                <span class="main-category__thumbnail-image" style="background-image:url('/images/main/main-pick8.png')"></span>
                            </span>
                            <span class="main-category__thumb-image"></span>
                        </span>
                        <span class="main-category__title">1</span>
                    </a>
                </div>
                <div class="swiper-slide">
                    <a class="main-category" href="#">
                        <span class="main-category__thumb">
                            <span class="main-category__thumbnail">
                                <span class="main-category__thumbnail-image" style="background-image:url('/images/main/main-pick8.png')"></span>
                            </span>
                            <span class="main-category__thumb-image"></span>
                        </span>
                        <span class="main-category__title">1</span>
                    </a>
                </div>
                <div class="swiper-slide">
                    <a class="main-category" href="#">
                        <span class="main-category__thumb">
                            <span class="main-category__thumbnail">
                                <span class="main-category__thumbnail-image" style="background-image:url('/images/main/main-pick8.png')"></span>
                            </span>
                            <span class="main-category__thumb-image"></span>
                        </span>
                        <span class="main-category__title">1</span>
                    </a>
                </div>
                <div class="swiper-slide">
                    <a class="main-category" href="#">
                        <span class="main-category__thumb">
                            <span class="main-category__thumbnail">
                                <span class="main-category__thumbnail-image" style="background-image:url('/images/main/main-pick8.png')"></span>
                            </span>
                            <span class="main-category__thumb-image"></span>
                        </span>
                        <span class="main-category__title">1</span>
                    </a>
                </div>
                <div class="swiper-slide">
                    <a class="main-category" href="#">
                        <span class="main-category__thumb">
                            <span class="main-category__thumbnail">
                                <span class="main-category__thumbnail-image" style="background-image:url('/images/main/main-pick8.png')"></span>
                            </span>
                            <span class="main-category__thumb-image"></span>
                        </span>
                        <span class="main-category__title">1</span>
                    </a>
                </div>
                <div class="swiper-slide">
                    <a class="main-category" href="#">
                        <span class="main-category__thumb">
                            <span class="main-category__thumbnail">
                                <span class="main-category__thumbnail-image" style="background-image:url('/images/main/main-pick8.png')"></span>
                            </span>
                            <span class="main-category__thumb-image"></span>
                        </span>
                        <span class="main-category__title">1</span>
                    </a>
                </div>
                <div class="swiper-slide">
                    <a class="main-category" href="#">
                        <span class="main-category__thumb">
                            <span class="main-category__thumbnail">
                                <span class="main-category__thumbnail-image" style="background-image:url('/images/main/main-pick8.png')"></span>
                            </span>
                            <span class="main-category__thumb-image"></span>
                        </span>
                        <span class="main-category__title">1</span>
                    </a>
                </div> -->
            </div>
        </div>
        <div class="main-category__pagination"></div>
        <div class="main-category__prev"></div>
        <div class="main-category__next"></div>
    </div>
</template>

<script>
import api from "@/api";
export default{
    data() {
        return{
            categories: []
        }
    },
	mounted() {
		this.init();
	},
	methods: {
		async init() {
            try{
                var { categories } = await api.v1.shop.categories.getCategories();
                this.categories = categories;

                this.render();
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
		},
        render(){
            this.$nextTick( () => {
                new Swiper ('.main-category-lists .swiper-container', {
					allowTouchMove: true,
                    spaceBetween : 30,
                    speed: 300,
                    loop: false,
                    slidesPerView: 10,
                    slidesPerGroup: 1,
                    pagination: {
                        el: '.main-category__pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.main-category__next',
                        prevEl: '.main-category__prev'
                    },
					breakpoints: {
						375: {
                            spaceBetween : 15,
							slidesPerView: 3,
                        },
						550: {
                            spaceBetween : 15,
							slidesPerView: 4,
                        },
                        768: {
                            spaceBetween : 15,
							slidesPerView: 6,
                        },
                        1024: {
                            spaceBetween : 15,
                            slidesPerView: 8,
                        },
                    }
                });
            });
        }
	},
}
</script>
